import React from 'react'

import { SocketProvider } from './context/SocketContext'
import { RouterPage } from './pages/RouterPage'
import { UiProvider } from './context/UiContext'

export const TicketApp = () => {
  return (
    <>
        <SocketProvider>
            <UiProvider
            breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
            minBreakpoint="xxs"
            >
                {/* <Sidebar /> */}
                  <RouterPage />
                
            </UiProvider>
        </SocketProvider>
        
    </>
  )
}
